'use strict';
import {siteConfig} from '../siteConfig';
const version = require('../version.json');

module.exports = function(departments, $state, Authentication, user, $scope, myTenant, $timeout, $q, $rootScope) {
    var _this = this;
    this.showNavs = !(localStorage.getItem('validationFormHideNavBar') === "1"); // for Validaction - Forms
    this.loggingOut = false;
    this.departments = departments.sort((deptA, deptB) => {
        let clientA = " ";
        if (deptA.client) clientA = deptA.client.name;
        let clientB = " ";
        if (deptB.client) clientB = deptB.client.name;    
        return (clientA.concat(deptA.name)).localeCompare(clientB.concat(deptB.name))
      });
    _this.lastSite=undefined
    _this.$state = $state;
    this.siteConfig = siteConfig;
    _this.webApps = [];
    const fromBuilder =
    {
        id: window.localStorage.$LoopBack$accessTokenId,
        user: Authentication.currentUserInfo().user || Authentication.currentUserInfo(),
    }
    const fromBuilderB64 = btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(fromBuilder))));
    siteConfig.webapp.map(app=>{        
        _this.webApps.push( {url:app.url.concat("/fromBuilder#", fromBuilderB64),title:app.title});
    });    
    this.Authentication = Authentication;
    this.user = user;
    this.builderVersion = version.builderVersion;

    // const VOOLKS_TENANT_ID = "56fc21e402a3885f336d8d3f";
    // this.isTenantVoolks = this.user && this.user.tenantId === VOOLKS_TENANT_ID;

    // TENANT VOOLKS CERTIFICATIONS
    this.myTenant = myTenant;
    _this.myTenant.load().then(() => {
        this.tenantId = _this.myTenant.get().id;
    })
    
    this.sidebarToggle = false;
    this.departmentsSectionOpen = true;
    this.toggleDepartmentsSection = () => {
        _this.departmentsSectionOpen = !_this.departmentsSectionOpen;
    };
    _this.currentUserIsViewer = Authentication.isOnlyViewerInDept(); 
    $scope.$watch(() => $state.params.departmentId, (newValue, oldValue) => {
        if (newValue !== oldValue) {
            _this.currentUserIsViewer = Authentication.isOnlyViewerInDept();
        }
    });
    this.currentUserIsAdmin = Authentication.isAuthorized("admin");
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");
    this.currentUserIsOwner = Authentication.isAuthorized("owner");
    if(this.currentUserIsOwner || this.currentUserIsSupervisor || this.currentUserIsAdmin  )
        _this.allowedTenantIdsForValidations = [
            '6654852498283e97620ff807', // Tenant Technology Bureau
            "56fc21e402a3885f336d8d3f", // Tenant Voolks
            "5f23071cc5643d8a126e5250", // EDENOR
        ];
    else
         _this.allowedTenantIdsForValidations = [];

    this.canShowValidationsButton = function() {
        if (this.siteConfig.tags && this.siteConfig.tags.includes('certdigital')) {
            return true;
        }        
        const currentTenant = myTenant.get();
        if (currentTenant && currentTenant.id) {
            if (_this.allowedTenantIdsForValidations.includes(currentTenant.id)) {
                return true;
            }
        }        
        return false;
    };

    _this.needHeader=function(dept){
        let result= _this.lastSite!= (dept.client?.name || undefined);
        if(result)
            _this.lastSite=(dept.client?.name || undefined);
        return result;        
    }
    this.showMenuBar = function () {
      return $state.params.departmentId && $state.current.name.indexOf('dashboard.departments') > -1;
    };

    this.departments.map(function(department) {
        if (department.id === $state.params.departmentId && $state.current.name.indexOf('dashboard') > -1) {
            department.open = true;
        } else {
            department.open = false;
        }
        return department;
    });

    this.toggleSidebar = function(outOfSidebar) {
        if (outOfSidebar) {
            _this.sidebarToggle = false;
            return;
        }
        _this.sidebarToggle = !_this.sidebarToggle;
        return;
    };

    this.logOut = () => {
        if (_this.loggingOut) {
            return;
        }
        _this.loggingOut = true;
        $rootScope.isLoggingOut = true;
        const minDelay = $timeout(angular.noop, 1500);
        const logoutPromise = Authentication.logOut().catch(() => {});
        return $q.all([logoutPromise, minDelay]).then(() => {
            $rootScope.isLoggingOut = false;
            return $state.go('login');
        });
    };

    //when clicking dashboard link we close the side menu by updating their "open" status to false.
    this.closeMenu = function() {
        _this.departments.map(function(department) {
            department.open = false;
            return department;
        });
    };

    this.goToState = function (stateName) {
        // console.log('Going to state:', stateName);
        return $state.go(stateName, {}, { reload: true });
    };

    this.saveDepartmentId = function(departmentId) {
        localStorage.setItem('lastDepartment', departmentId);
    };
    // console.log('$state', $state)

    _this.showDropdownMenu = false; // Controls visibility of the dropdown menu
    
    _this.toggleDropdownMenu = function() {
        _this.showDropdownMenu = !_this.showDropdownMenu;
    };
};
